import Index from '@/views/index'
import jdyrole from '@/common/jdyrole';

export const order = {
  path: '/order',
  redirect: '/order/business/list',
  component: Index,
  name: 'order',
  meta: {
    title:'筋斗云-业务管理',
    requiresAuth: true,
    requiresRole: [jdyrole.superadmin,jdyrole.claimbiz,jdyrole.bizread,jdyrole.salesmanager, jdyrole.salessupervisor, jdyrole.salesassistant]
  },
  children: [
    //{
    //path: '/order/production/list',
    //components: { default: () => import('@/views/order/production/list') },
    //name: 'productionlist',
    //meta: {
    //  requiresAuth: true,
    //  requiresRole: [jdyrole.superadmin, jdyrole.salesmanager, jdyrole.salessupervisor, jdyrole.salesassistant]
    //}
    //},
    {
    path: '/order/business/list',
    components: { default: () => import('@/views/order/business/list') },
    name: 'businesslist',
    meta: {
      title:'筋斗云-业务管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim,
        jdyrole.bizreadteam, jdyrole.claimbizbymanager, jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer]
    }
  }, {
    path: '/order/business/detail',
    components: { default: () => import('@/views/order/business/detail') },
    name: 'businessdetail',
    meta: {
      title:'筋斗云-业务详情',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim,
        jdyrole.bizreadteam, jdyrole.claimbizbymanager, jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer]
    }
  },  {
    path: '/order/orderClaim/list',
    components: { default: () => import('@/views/order/orderClaim/list') },
    name: 'orderClaimlist',
    meta: {
      title:'筋斗云-订单认领',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim,
        jdyrole.bizreadteam, jdyrole.claimbizbymanager, jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer]
    }
  }, {
    path: '/order/list',
    components: { default: () => import('@/views/order/order/list') },
    name: 'orderlist',
    meta: {
      title:'筋斗云-订单管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim,
        jdyrole.bizreadteam, jdyrole.claimbizbymanager, jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer]
    }
  }, {
    path: '/order/detail',
    components: { default: () => import('@/views/order/order/detail') },
    name: 'orderdetail',
    meta: {
      title:'筋斗云-订单详情',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim,
        jdyrole.bizreadteam, jdyrole.claimbizbymanager, jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer]
    }
  }]
}




// WEBPACK FOOTER //
// ./src/router/order/index.js